import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { logError } from '../utils/logger';

const AuthCallback = () => {
  const { handleAuthCallback } = useAuth();
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const processAuth = async () => {
      try {
        // Extract code from URL
        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        
        if (!code) {
          logError('No authentication code received');
          setError('No authentication code received');
          return;
        }
        
        const success = await handleAuthCallback(code);
        if (success) {
          navigate('/map');
        } else {
          logError('Authentication failed');
          setError('Authentication failed');
        }
      } catch (err) {
        logError(err.message || 'Authentication failed');
        setError(err.message || 'Authentication failed');
      }
    };

    processAuth();
  }, [handleAuthCallback, location, navigate]);

  return (
    <div className="auth-callback-container">
      {error ? (
        <div className="auth-error">
          <h3>Authentication Error</h3>
          <p>{error}</p>
          <button onClick={() => navigate('/login')}>Return to Login</button>
        </div>
      ) : (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Authenticating...</p>
        </div>
      )}
    </div>
  );
};

export default AuthCallback;